$('.share').on('click', function(e){
    e.preventDefault();
    var url = window.location.href;
    navigator.share({
        url: url,
        title: "La Vanguardia",
        text: "Comparte esta notícia:"
    });
});